export const projects = [
  {
    title: 'React Reserve',
    subtitle: 'MERN Stack',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?',
    image: './project-1.gif',
    link: 'https://reactbootcamp.com',
  },
  {
    title: 'React Tracks',
    subtitle: 'React and Python',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?',
    image: './project-2.gif',
    link: 'https://reactbootcamp.com',
  },
  {
    title: 'DevChat',
    subtitle: 'React and Firebase',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?',
    image: './project-3.gif',
    link: 'https://reactbootcamp.com',
  },
  {
    title: 'Epic Todo App',
    subtitle: 'React Hooks',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?',
    image: './project-4.gif',
    link: 'https://reactbootcamp.com',
  },
];

export const testimonials = [
  {
    quote:
      '"I had the pleasure of working on a complex software project, and I can confidently say that they exceeded my expectations in every way. Their expertise in JavaScript, React, and other related technologies was instrumental in delivering a high-quality, scalable solution on time and within budget. They were always professional, communicative, and responsive throughout the project, and I would not hesitate to recommend them for any technical project."',
    image: 'https://randomuser.me/api/portraits/men/1.jpg',
    name: 'Jesse Hicks',
    company: 'Zoozle',
  },
  {
    quote:
      '"He is an exceptional developer with a keen eye for detail and a deep understanding of software architecture. They were instrumental in helping us migrate our Plone CMS to a new server, ensuring minimal downtime and a seamless transition for our users. Their ability to identify and troubleshoot issues quickly saved us time and money, and their commitment to quality was evident in every aspect of their work. We look forward to working with you again in the future."',
    image: 'https://randomuser.me/api/portraits/men/94.jpg',
    name: 'Ruben Alvarez',
    company: 'Dooble.io',
  },
];

export const skills = [
  'JavaScript',
  'React',
  'Odoo',
  'Plone CMS',
  'Python',
  'Postgresql',
  'Node',
  'GraphQL',
  'Material UI',
];
